import { useState } from 'react';

import { EntityFilters } from './entity-filters';
import CustomModal from '@/components/molecules/Modals/CustomModal';
import { DebouncedSearchInput } from '@/new/components/debounced-search-input';
import { Icon } from '@/new/components/icon';
import { Pagination } from '@/new/components/pagination';
import { Button } from '@/new/components/shadcn/button';
import { PersonFiltersV2 } from '@/types';

interface EntityHeaderProps {
  onSearchCall: (value: string) => void;
  currentPage: number;
  totalPages: number | undefined;
  activeFilters: PersonFiltersV2;
  setFilters: (v: PersonFiltersV2) => void;
  filterCount: number;
  prevPage: () => void;
  nextPage: () => void;
  goToPage: (page: number) => void;
  openDownloadModal: () => void;
  totalCount: number | undefined;
  filteredCount: number | undefined;
}

export const EntityHeader = ({
  onSearchCall,
  currentPage,
  totalPages,
  activeFilters,
  setFilters,
  filterCount,
  prevPage,
  nextPage,
  goToPage,
  openDownloadModal,
  totalCount,
  filteredCount,
}: EntityHeaderProps) => {
  const [filtersModalOpen, setFiltersModalOpen] = useState(false);

  return (
    <div className="flex items-center justify-between gap-2 border-b p-4">
      <Button onClick={openDownloadModal}>
        <Icon className="lucide--download" />
        Download
      </Button>

      <div className="flex items-center gap-2">
        <Button onClick={() => setFiltersModalOpen(true)} className="relative">
          <Icon className="lucide--filter" />
          Filter
          {filterCount > 0 && (
            <span className="absolute -top-2 -right-2 flex size-4.5 items-center justify-center rounded-full border border-teal-400 bg-teal-50 pt-[1px] text-xs font-medium text-teal-600">
              {filterCount}
            </span>
          )}
        </Button>

        <DebouncedSearchInput onSearchCall={onSearchCall} placeholder="Search entities..." />
        <Pagination
          canGetPrevPage={currentPage > 0}
          canGetNextPage={totalPages !== undefined && currentPage < totalPages - 1}
          prevPage={prevPage}
          nextPage={nextPage}
          currentPage={currentPage}
          noOfPages={totalPages}
          goToPage={goToPage}
          totalCount={totalCount}
          filteredCount={filteredCount}
          entityName="entities"
        />
      </div>

      <CustomModal
        content={
          <EntityFilters
            activeFilters={activeFilters}
            setFilters={setFilters}
            handleClose={() => setFiltersModalOpen(false)}
            goToPage={goToPage}
          />
        }
        isOpen={filtersModalOpen}
        maxWidth="32rem"
        handleClose={() => setFiltersModalOpen(false)}
      />
    </div>
  );
};
